import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { AppRoutes } from "constants/routes";
import RoleListPage from "./RoleListPage";

const RoleRouter = () => (
  <Switch>
    <Route exact path={AppRoutes.Roles} component={RoleListPage} />
    <Route render={() => <Redirect to={AdminRoutes.Roles} />} />
  </Switch>
);

export default RoleRouter;
